import Column from './Column';
import formatPrismicData from '../../hocs/formatPrismicData';

export default formatPrismicData(Column);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Column/index.js